// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8e2e5230","889":"5407a911"}[chunkId] + ".chunk.js";
};